let accessToken = null;
let refreshToken = null;
let userData = null;

const tokenStorage = {
  getAccessToken: () => accessToken,
  setAccessToken: (token) => {
    accessToken = token;
    // Migration period: also write to localStorage for components not yet migrated
    if (token) {
      localStorage.setItem('jwtToken', token);
    } else {
      localStorage.removeItem('jwtToken');
    }
  },

  getRefreshToken: () => refreshToken,
  setRefreshToken: (token) => {
    refreshToken = token;
  },

  getUserData: () => userData,
  setUserData: (data) => {
    userData = data;
    // Migration period: also write to localStorage
    if (data) {
      localStorage.setItem('userData', JSON.stringify(data));
    } else {
      localStorage.removeItem('userData');
    }
  },

  clear: () => {
    accessToken = null;
    refreshToken = null;
    userData = null;
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('userData');
  },

  // Hydrate in-memory store from localStorage on app startup (migration helper)
  hydrateFromLocalStorage: () => {
    const storedToken = localStorage.getItem('jwtToken');
    const storedUserData = localStorage.getItem('userData');

    if (storedToken && !accessToken) {
      accessToken = storedToken;
    }
    if (storedUserData && !userData) {
      try {
        userData = JSON.parse(storedUserData);
      } catch {
        // Invalid JSON, ignore
      }
    }
  },
};

export default tokenStorage;
